fx.ns("shared.components", class CoverThumbText extends shared.components.CoverThumb 
{    
    constructor(parameters)
    {
        super(parameters);
    }

    load()
    {
        super.load();

        if(this.data.content == "")
        {
            this.ready();
            return;
        }

        this.originalWidth = this.elementWidth / this.creationSize.ratio;
        this.originalHeight = this.elementHeight / this.creationSize.ratio;

        var htmlObject = document.createElement('div');
        var fontsize = "4px"; // default font size
        /*var ql_container = fx.dom.find(".Text[data-id="+this.data.id+"] .ql-container");
        if(ql_container != null)
        {
            if (Array.isArray(ql_container))
                ql_container = ql_container[0];
            
            fontsize = ql_container.firstChild.style.fontSize;
        }*/

        // when creating thumb of ThemeLayout, we put some light grey color on texts
        let bgcolor = (this.data instanceof models.ThemeLayoutComponent) ? "#e9e9e9" : this.data.bgcolor;
            
        htmlObject.innerHTML = 
        `<div id="uuid-ksbmnhly" class="Text BaseComponent Component" data-id="`+this.data.id+`" style="opacity: 1; visibility: visible; outline: none; background-color: `+ bgcolor +`; width: `+Math.round(this.originalWidth)+`px; height: `+Math.round(this.originalHeight)+`px; ">
            <div id="uuid-ksbmnhmg" class="Box Component text ql-container ql-disabled" style="height: inherit; top: 5px; left: 5px; opacity: 1; visibility: visible; position: absolute; width: `+((this.originalWidth)-10)+`px;">
                <div class="ql-editor" data-gramm="false" contenteditable="false" style="font-family: ' '; text-align: left; font-size: `+fontsize+`; color: `+this.data.color+`;">
                `+this.data.content+`
                </div>
            </div>
        </div>`;

        var texts = [];
        var elements = ["span", "strong", "em", "p"];
        var text;
        for (var i = 0; i<elements.length; i++)
        {
            text = fx.dom.find(elements[i], htmlObject);
            if(text != null)
                break;
        }

        if(text === null)
        {
            this.ready();
            return;
        }

        if (Array.isArray(text))
            texts = text;
        else
            texts.push(text);

        for(var i=0 ; i<texts.length; i++)
        {
            texts[i].style.whiteSpace = "pre-warp";
            texts[i].style.wordBreak = "break-word";
            texts[i].style.margin = 0;
            texts[i].style.padding = 0;
            texts[i].style.lineHeight = 1.34;
        }

        var textContainers = [];
        var textContainer = fx.dom.find("p", htmlObject);
        if(textContainer === null)
        {
            this.ready();
            return;
        }

        if(Array.isArray(textContainer))
            textContainers = textContainer;
        else
            textContainers.push(textContainer);

        for(var i=0 ; i<textContainers.length; i++)
        {
            textContainers[i].style.wordBreak = "break-word";
            textContainers[i].style.margin = 0;
            textContainers[i].style.padding = 0;
        }

        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${Math.round(this.originalWidth)}" height="${Math.round(this.originalHeight)}">
        <foreignObject width="100%" height="100%">
        <style>`+this.fontstyle+`</style>
        <div xmlns="http://www.w3.org/1999/xhtml">${htmlObject.innerHTML.replace(/<br>/g, '<br/>')}</div>
        </foreignObject>
        </svg>`;
        // we replace <br> by <br/> because foreign object only takes xhtml elements

        window.unescape = window.unescape || window.decodeURI;
        var b64 = window.btoa(unescape(encodeURIComponent(svg)));

        let tempImg = new Image();
        this.on("load", this.drawTextOnCanvas, tempImg);
        this.on("error", this.onLoadError, tempImg);
        tempImg.src = "data:image/svg+xml;base64," + b64;
    }


    drawTextOnCanvas(event)
    {
        var img = event.target;

        this.context.save();
        this.context.translate(this.elementX-this.offset, this.elementY);
        this.context.rotate(this.elementRotation*this.TO_RADIANS);
        this.context.translate(-(this.elementX-this.offset), -this.elementY);
        this.context.drawImage( img, 0, 0, this.originalWidth, this.originalHeight, this.elementX-this.offset, this.elementY, this.elementWidth, this.elementHeight);

        if(this.data.borderid>0)
        {
            this.context.lineWidth = this.data.borderid * this.creationSize.ratio;
            this.context.strokeStyle = this.data.side;
            this.context.strokeRect(this.elementX-this.offset-parseInt(this.data.borderid)/2, this.elementY-parseInt(this.data.borderid)/2, Math.round(this.elementWidth)+parseInt(this.data.borderid), Math.round(this.elementHeight)+parseInt(this.data.borderid));//for white background
        }

        this.context.restore();

        this.ready();
    }

});